import { CompatibilityResponse } from 'ctp-compatibility-checker';

const getters = {
  getCompatibility(): CompatibilityResponse[] {
    return [{
      licencePlateNumber: 'AC123CD',
      brand: 'VOLVO',
      model: 'FH(3)',
      dtcoData: {
        manufacturerCode: '1234',
        firmwareVersion: 'DTCO 4.1',
        tollingSupported: true
      },
      eetsTolling: false,
      polandEToll: true,
      liveTracking: true,
      remoteDownload: true
    },
    {
      licencePlateNumber: 'XY456YZ',
      brand: 'Daimler',
      model: 'Arocs',
      dtcoData: {
        manufacturerCode: '1234',
        firmwareVersion: 'DTCO 4.1',
        tollingSupported: true
      },
      eetsTolling: false,
      polandEToll: true,
      liveTracking: true,
      remoteDownload: true
    }];
  }
};
export default getters;
